
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, Injectable, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { ToastrModule } from 'ngx-toastr';
import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting
import { ColorPickerModule } from 'ngx-color-picker';
import { CreateTagModule } from './shared/tags/create-tag/create-tag.module';
import { CustomTooltipModule } from 'app/shared/directives/tooltip-directive.module';
import { MaterialModule } from './demo-material-module';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { SharedModule } from './shared/shared.module';
import { AuthModule } from './auth/auth.module';
import { GraphQLModule } from './graphql.module';
import { TreeModule } from 'primeng/tree';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FullComponent } from './layouts/full/full.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './layouts/full/breadcrumb/breadcrumb.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardSidebarComponent } from 'app/layouts/full/dashboard-sidebar/dashboard-sidebar.component';
import { SpinnerComponent } from './shared/spinner.component';
import { AuthGuard } from './auth.guard';
import { RestInterceptor } from './shared/interceptors/rest.interceptor';
import { ComponentsService } from './components/services/components.service';
import { RouteNavLockService } from './services/route-nav-lock.service';
import { ModelsService } from './models/services/models.service';
import { TagsService } from 'app/shared/services/tags.service';
import { LoginService } from './auth/services/login.service';
import { AppConfig } from './app-config';

export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    console.log('*#*ERROR: ', error);
  }
}

export function tokenGetter() {
  return localStorage.getItem('Token');
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@Injectable()

// @ts-ignore
@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
    AppBreadcrumbComponent,
    DashboardSidebarComponent,
    // ChartsComponent // mock component
  ],
  imports: [
    BrowserModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes, { useHash: true, relativeLinkResolution: 'legacy', initialNavigation: 'enabled' }),
    AuthModule,
    MatMenuModule,
    ColorPickerModule,
    MatAutocompleteModule,
    BrowserAnimationsModule, // required animations module
    BreadcrumbModule,
    ToastrModule.forRoot(
      {
        closeButton: true,
      }
    ),
    GraphQLModule,
    ReactiveFormsModule,
    TreeModule,
    CreateTagModule,
    CustomTooltipModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AuthGuard,
    ModelsService,
    ComponentsService,
    RouteNavLockService,
    LoginService,
    TagsService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestInterceptor,
      multi: true
    },
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }

export function initializeApp(appConfig: AppConfig) {
  return () => { appConfig.load(); };
}
